import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { replaceUnderscoresUpperCase } from "~/common/utils";
import {
  DirectInquiryType,
  IndirectInquiryType,
} from "~/providers/utils/types/patientIntakePreview";

export interface InquiriesLayoutProps extends PropsWithChildren {
  title: string;
  classification: DirectInquiryType | IndirectInquiryType;
  classificationClassName: string;
}

export const InquiriesLayout = ({
  title,
  children,
  classification,
  classificationClassName,
}: InquiriesLayoutProps) => (
  <div className="flex w-full flex-col gap-1 rounded-md bg-primary-50 p-3">
    <div className="flex h-auto justify-between">
      <span className="text-sm font-semibold text-gray-950">{title}</span>
      <span
        className={twMerge(
          "font-medium first-letter:uppercase",
          classification === "n/a" && "uppercase",
          classificationClassName,
        )}
      >
        {replaceUnderscoresUpperCase(classification)}
      </span>
    </div>
    {children}
  </div>
);
